import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { createQueryConfig } from "@circle-react/providers/QueryClient/reactQueryConfig";
import { ControlledThemeProvider } from "@circle-react/providers/Theme";
import type { PropsWithChildren } from "react";
import { QueryClient } from "react-query";

import { ToastProvider } from "@/react/components/SettingsApp/CompassCompat/Toast";

import { useCheckoutTitle } from "../hooks/useCheckoutTitle";
import type { CheckoutProps } from "../types/CheckoutProps";
import { FormWrapper } from "./FormWrapper";

const queryClient = new QueryClient(createQueryConfig());

export const CheckoutWrapper = Object.assign(
  ({ children, ...checkoutProps }: PropsWithChildren<CheckoutProps>) => {
    const title = useCheckoutTitle(checkoutProps);

    return (
      <>
        <title>{title}</title>
        <ControlledThemeProvider>
          <QueryClientProvider client={queryClient}>
            <ToastProvider>
              <FormWrapper {...checkoutProps}>{children}</FormWrapper>
            </ToastProvider>
          </QueryClientProvider>
        </ControlledThemeProvider>
      </>
    );
  },
  {
    Preview: ({
      children,
      ...checkoutProps
    }: PropsWithChildren<CheckoutProps>) => (
      <FormWrapper {...checkoutProps}>{children}</FormWrapper>
    ),
  },
);
